import {getField, updateField} from 'vuex-map-fields';
import BatchRunDialog from '@/commonFunction/baseTableModule'

let batch_run = new BatchRunDialog('/ws/table/batch_run/');

const state = {
    ...batch_run.state,
    columns: [
        {text: '', value: 'notion_id', sortable: false, divider: false, width: 30, brief: true,},
        // {text: 'modified_auto', value: 'modified_auto', sortable: false, divider: true, width: 30, brief: true,},
        // {text: '#', value: 'number', sortable: false, divider: true, width: 30, brief: true,},
        {text: '', value: 'actions', sortable: false, divider: true, width: 30, brief: true,},
        {text: 'wd', value: 'batch_run_week_day__week_day', sortable: false, divider: true, width: 30, brief: true,},
        {text: 'Title', value: 'title', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Status', value: 'status', sortable: false, divider: true, brief: true,},
        {text: 'Target date', value: 'delivery_date', sortable: false, filterable: true, divider: true, width: 110, brief:true,},
        {text: 'SMD', value: 'smd', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'THT', value: 'tht', sortable: false, divider: true, brief: true,},
        {text: 'SMD date range', value: 'smd_start_plan', sortable: false, divider: true, width: 185, brief: true,},
        {text: 'THT date range', value: 'tht_start_plan', sortable: false, divider: true, width: 185, brief: true,},
        {text: 'SMD FTE/day', value: 'smd_real_fte', sortable: false, divider: true, width: 30, brief: true,},
        {text: 'THT FTE/day', value: 'tht_real_fte', sortable: false, divider: true, width: 30, brief: true,},
        // {text: 'SMD start plan', value: 'smd_start_plan', sortable: true, divider: true, brief: true,},
        // {text: 'SMD end plan', value: 'smd_end_plan', sortable: true, divider: true, brief: true,},
        // {text: 'THT start plan', value: 'tht_start_plan', sortable: true, divider: true, brief: true,},
        // {text: 'THT end plan', value: 'tht_end_plan', sortable: true, divider: true, brief: true,},
    ],
    options: {
                page: 1,
                itemsPerPage: 100,
                sortBy: ['batch_run_week_day__week_day'],
                sortDesc: [false],
                multiSort: false,
                mustSort: false,
                descending: false,

            },
};
const getters = {
    ...batch_run.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...batch_run.actions,
};
const mutations = {
    ...batch_run.mutations,
};

export default {
    modules: {
        BatchRunDialog: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}

// const baseUrl = '/api/quote/'
// const wsURL = '/ws/table/customer/'